import * as React from "react";
import Dialog from "@mui/material/Dialog";
import List from "@mui/material/List";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { Search } from "@mui/icons-material";
import { ListItemButton, Skeleton } from "@mui/material";
import { useMutation } from "react-query";
import { searchProductsFn } from "../../Services/Products/Search";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SearchModal = () => {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [searchProducts, setSearchProducts] = React.useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const { mutate: search, isLoading } = useMutation(searchProductsFn, {
    onSuccess: (response) => {
      setSearchProducts(response.data.data.product_list);
    },
  });
  const navigate = useNavigate();
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  React.useEffect(
    () => {
      value !== "" && search({ search: value });
    },
    // eslint-disable-next-line
    [value]
  );
  return (
    <>
      <Search onClick={handleClickOpen} />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <div className="flex fixed w-full z-50 bg-inherit items-center justify-between h-16 px-3 shadow">
          <span className="flex items-center gap-4">
            <Search />

            <input
              type="text"
              placeholder="Search Bhaarat Store"
              className="outline-none bg-transparent"
              onChange={handleChange}
            />
          </span>

          <CloseIcon onClick={handleClose} className="!text-2xl" />
        </div>
        <div className="p-1">
          {isLoading ? (
            <div className="!mt-[63px] rounded flex flex-col !h-full gap-2 bg-zinc-100 dark:bg-zinc-800 w-full !p-2 px-3">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map((product) => {
                return (
                  <span className="flex gap-2 items-center w-full">
                    <span className="w-[15%]">
                      <Skeleton className="!h-12 !scale-100 !w-full" />
                    </span>
                    <span className="flex flex-col gap-1 w-full">
                      <Skeleton className="w-full" />
                      <Skeleton className="w-1/2" />
                    </span>
                  </span>
                );
              })}
            </div>
          ) : (
            <List
              className={classNames(
                "!mt-[63px] !rounded !p-2 hidden h-!full !shadow !shadow-zinc-300 dark:!shadow-zinc-700 !bg-zinc-100 dark:!bg-zinc-800",
                value !== "" && "!block"
              )}
            >
              {searchProducts?.map((product) => {
                return (
                  <ListItemButton
                    className="dark:hover:!bg-zinc-900 hover:!bg-zinc-200 !p-2 !px-3 !rounded"
                    onClick={() =>
                      navigate(`/product`, {
                        state: { product_id: product.id },
                      })
                    }
                  >
                    <span className="flex gap-2 items-center">
                      <img
                        src={product.variant_image}
                        alt=""
                        className="h-12"
                      />
                      <span>
                        <p className="w-[280px] font-semibold text-ellipsis whitespace-nowrap overflow-hidden">
                          {product.variant_name}
                        </p>
                        <p>{product.main_category}</p>
                      </span>
                    </span>
                  </ListItemButton>
                );
              })}
            </List>
          )}
        </div>
      </Dialog>
    </>
  );
};
export default SearchModal;
